import $ from 'jquery';
import {Swiper, Navigation, Autoplay} from 'swiper/swiper.esm.js';
Swiper.use([Navigation, Autoplay]);

const swiper = new Swiper('.break-swiper', {
    slidesPerView: 1,
    loop: true,
    autoHeight: true,
    spaceBetween: 30,
    autoplay: {
        delay: 4000
    },
    speed: 2000,
    breakpoints:{
        1300: {
            slidesPerView: 3,
        },
        750: {
            slidesPerView: 2,
        },
    }
});
